import {HttpClient, HttpHandler} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable()

export class SessionDataApi extends HttpClient {
    private baseUrl = environment.production ? '/channel-virtual/api/v1' + '/virtual' : environment.baseUrl + '/virtual';
    private loginUrl = environment.production ? '/channel-virtual' + '/login' : environment.baseUrlLogin + '/login';

    public constructor(handler: HttpHandler) {
        super(handler);
    }

    public login(): Observable<any> {
        return super.get(this.loginUrl);
    }

    public getSessionToken(token,version?:number) {
        let url = this.baseUrl + '/initialise/' + token;
        if(!isNaN(version)){
          url += '?version='+version; 
        }
        return super.post(url, '');
    }

  public getSessionTokenWithNoSession(token,complete?:boolean) {
    let url = this.baseUrl + '/validate/initialise/' + token;
    if(complete!=undefined){
      url += '?complete='+complete; 
    }
    return super.post(url, '');
  }

}
